/* eslint-disable jsx-a11y/anchor-is-valid */
import { forwardRef } from 'react'
import { Link } from 'react-router-dom'
import { AiOutlineClose } from '@react-icons/all-files/ai/AiOutlineClose'
import { useSelector } from 'react-redux'

const SiteMap = forwardRef(({ handleClose }, ref) => {
	const { menu, isAllowAdmin } = useSelector(state => state.navigation)

	const renderMenu = item => {
		if (item.accessCode?.startsWith('N')) {
			return (
				<li key={item.menuID} className={item.isNeedLineBreak ? 'g-line' : ''}>
					<span className="cursor-not-allowed text-slate-400">{item.menuName}</span>
				</li>
			)
		}

		return (
			<li key={item.menuID} className={item.isNeedLineBreak ? 'g-line' : ''}>
				{item.isBiPage ? (
					<a
						className={!item.biLink ? 'cursor-default !text-gray-700' : ''}
						href={item.biLink}
						target="_blank"
						rel="noreferrer"
						onClick={handleClose}
					>
						{item.menuName}
					</a>
				) : (
					<Link to={item.link}>{item.menuName}</Link>
				)}
			</li>
		)
	}

	return (
		<div className="sitemap" ref={ref}>
			<button
				className="btn secondary min-h-0 absolute right-5 top-5"
				onClick={handleClose}
			>
				<AiOutlineClose />
				<span>Close</span>
			</button>

			<div className="container mx-auto">
				<div className="grid grid-cols-2 gap-3 lg:grid-cols-4 lg:gap-5">
					<div>
						<div>
							<h2 className="text-ci5 text-lg">Crude</h2>
							<ul>{menu['Crude'].map(renderMenu)}</ul>
						</div>
					</div>

					<div>
						<div>
							<h2 className="text-ci5 text-lg">Products</h2>
							<ul>{menu['Products'].map(renderMenu)}</ul>
						</div>

						<div className="mt-8">
							<h2 className="text-ci5 text-lg">Petrochemical</h2>
							<ul>{menu['Petrochemical'].map(renderMenu)}</ul>
						</div>
					</div>

					<div className="mt-5 lg:mt-0">
						<div>
							<h2 className="text-ci5 text-lg">Chartering</h2>
							<ul>{menu['Chartering'].map(renderMenu)}</ul>
						</div>

						<div className="mt-8">
							<h2 className="text-ci5 text-lg">Derivatives</h2>
							<ul>{menu['Derivatives'].map(renderMenu)}</ul>
						</div>
					</div>

					<div>
						<div>
							<h2 className="text-ci5 text-lg">Market Analysis</h2>
							<ul>{menu['MarketAnalysis'].map(renderMenu)}</ul>
						</div>

						<div className="mt-8">
							<h2 className="text-ci5 text-lg">Miscellaneous</h2>
							<ul>
								<li>
									<a
										href="https://oneplatform.pttplc.com/uploads/manual/oneplatform_usermanual_v2.pdf"
										target="_blank"
										rel="noreferrer"
									>
										User Manual
									</a>
								</li>
								<li>
									<a
										href="https://oneplatform.pttplc.com/uploads/manual/oneplatform_usermanual_en.pdf"
										target="_blank"
										rel="noreferrer"
									>
										User Manual (Eng)
									</a>
								</li>
								{isAllowAdmin && (
									<li className="g-line">
										<a href="/admin" target="_blank">
											Admin System
										</a>
									</li>
								)}
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
})

export default SiteMap
